import React from 'react';
import ReactDOM from 'react-dom';
import PopulationSpreadSim from './PopulationSpreadSim'
import { simulator, initializeSimulationState, statesList, linkRenderer, nodesRenderer } from './withDeathSimulator'
import TextSpanPortal from './TextSpanPortal'

const LargeImmunocompromisedSim = ({ portalId, graph, deathRates }) => {
  return ReactDOM.createPortal(
    <PopulationSpreadSim
      width={600}
      height={550}
      simulator={simulator}
      statesList={statesList}
      initializeSimulationState={initializeSimulationState}
      linkRenderer={linkRenderer}
      nodesRenderer={nodesRenderer}
      graph={graph}
      controls={deathRates}
      zoom={0.75}
    />,
    document.getElementById(portalId)
  );
};

export default LargeImmunocompromisedSim;